// Central content for Agraj Enterprise site

export const CONTACT = {
  person: "Shravan K. Bhirbhidiya",
  phone: "+91 78188 11818",
  phoneRaw: "917818811818",
  email: "agrajenterprise925@gmail.com",
  address:
    "150 Ft Ring Road, Plot No.104, Flat A/408, Opp. Leela Udaan, Sitaram Nagar, Ruva, Bhavnagar, Gujarat, 364001",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1781156210760-7d33f6ccc893",
  services: "https://images.unsplash.com/photo-1781156771445-404a80d7ee7a",
  industries: "https://images.unsplash.com/photo-1781359502942-197e551e24e2",
  safety: "https://images.unsplash.com/photo-1681812508281-7589b75b2e46",
};

export const STATS = [
  { value: 7, suffix: "+", label: "Years Experience" },
  { value: 100, suffix: "+", label: "Projects Delivered" },
  { value: 100, suffix: "%", label: "Safety First" },
  { value: 12, suffix: "+", label: "Industrial Clients" },
];

export const SERVICES = [
  { icon: "Brush", title: "Structural Painting", desc: "Precision painting for steel structures ensuring lasting protection & finish." },
  { icon: "Layers", title: "Industrial Coating", desc: "High-performance coating systems engineered for demanding environments." },
  { icon: "ShieldCheck", title: "Epoxy Coating", desc: "Chemical & abrasion resistant epoxy systems for floors and structures." },
  { icon: "Droplets", title: "PU Coating", desc: "UV-stable polyurethane top coats for durability and gloss retention." },
  { icon: "Paintbrush", title: "Alkyd Coating", desc: "Cost-effective alkyd systems for general industrial protection." },
  { icon: "Zap", title: "Zinc Coating", desc: "Zinc-rich primers delivering galvanic corrosion protection." },
  { icon: "Grid2x2", title: "Surface Preparation", desc: "Cleaning, grinding & profiling for superior coating adhesion." },
  { icon: "Wind", title: "Sand Blasting", desc: "Abrasive blasting to achieve the required surface standard." },
  { icon: "Eraser", title: "Rust Removal", desc: "Effective rust removal & surface treatment before coating." },
  { icon: "ShieldAlert", title: "Corrosion Protection", desc: "Multi-layer protective systems that shield assets for years." },
  { icon: "Factory", title: "Factory Painting", desc: "Complete factory painting with minimal production downtime." },
  { icon: "Warehouse", title: "Warehouse Painting", desc: "Large-span warehouse interior & exterior painting solutions." },
  { icon: "Wrench", title: "Plant Maintenance", desc: "Scheduled maintenance painting to extend plant asset life." },
  { icon: "Hammer", title: "Retrofitting", desc: "Structural retrofitting and reinforcement to upgrade existing assets and extend their service life." },
  { icon: "ScanSearch", title: "Non Destructive Testing (NDT)", desc: "Ultrasonic, radiographic and visual NDT inspections to verify integrity without damaging the structure." },
  { icon: "Activity", title: "Vibration Control", desc: "Vibration analysis and control solutions to protect equipment, structures and improve operational stability." },
];

export const INDUSTRIES = [
  { title: "Caustic Soda Plants", icon: "Beaker", image: "https://images.unsplash.com/photo-1566226196556-ef949ce5f1a3" },
  { title: "PPA Plants", icon: "Atom", image: "https://images.unsplash.com/photo-1546185058-592ead754d27" },
  { title: "Warehouses", icon: "Warehouse", image: "https://images.unsplash.com/photo-1758789667762-56175fe4601c" },
  { title: "Factories", icon: "Factory", image: "https://images.unsplash.com/photo-1511454493857-0a29f2c023c7" },
  { title: "Steel Structures", icon: "Building2", image: "https://images.unsplash.com/photo-1609627016501-b862497c7294" },
  { title: "Industrial Buildings", icon: "Building", image: "https://images.unsplash.com/photo-1615797534094-7fde0a4861f3" },
  { title: "Manufacturing Plants", icon: "Cog", image: "https://images.unsplash.com/photo-1647427060118-4911c9821b82" },
];

export const PAINTING_SERVICES = [
  {
    title: "Interior Painting",
    icon: "PaintRoller",
    image: "https://images.unsplash.com/photo-1693985120993-e9b203ce7631",
    desc: "Clean, precise interior wall and surface painting for offices, plants and facilities — smooth finishes with minimal disruption to your operations.",
    points: ["Wall & ceiling painting", "Primer & putty work", "Low-odour, durable finishes"],
  },
  {
    title: "Exterior Painting",
    icon: "Paintbrush",
    image: "https://images.unsplash.com/photo-1574359411659-15573a27fd0c",
    desc: "Weather-resistant exterior painting for buildings and structures — protective, long-lasting coatings that stand up to sun, rain and industrial exposure.",
    points: ["Facade & elevation painting", "Weatherproof coatings", "Work at height with full PPE"],
  },
];

export const SPECIALTY_SERVICES = [
  {
    title: "Retrofitting",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1610551675799-50d4d0fe0252",
    desc: "Strengthen and upgrade existing structures with engineered retrofitting solutions — extending service life, improving load capacity and bringing older assets up to modern safety standards.",
    points: [
      "Structural strengthening & jacketing",
      "Steel reinforcement & bracing",
      "Rehabilitation of aged concrete & steel",
      "Seismic & load upgrade solutions",
    ],
  },
  {
    title: "Non Destructive Testing (NDT)",
    icon: "ScanSearch",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_agraj-preview/artifacts/qtty7nrx_WhatsApp%20Image%202026-09-04%20at%205.12.46%20PM%20%281%29.jpeg",
    desc: "Specialised NDT services for civil construction — evaluate the quality, strength and durability of concrete and RCC structures without causing any damage. Ideal for existing buildings, retrofits and quality assurance on new works.",
    points: [
      "Rebound Hammer Test",
      "Ultrasonic Pulse Velocity Test",
      "Half-Cell Potentiometer Test",
    ],
  },
  {
    title: "Vibration Control",
    icon: "Activity",
    image: "https://images.unsplash.com/photo-1620203853151-496c7228306c",
    desc: "Diagnose and mitigate harmful vibrations on rotating equipment, pipelines and structures — improving machine life, reducing downtime and protecting your plant.",
    points: [
      "Vibration measurement & analysis",
      "Isolators, dampers & tuned mass solutions",
      "Alignment & balancing support",
      "Structural vibration mitigation",
    ],
  },
];



export const GALLERY = [
  {
    id: 1,
    title: "Structural Steel Tower",
    category: "Steel Structures",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_agraj-preview/artifacts/qa82lmor_WhatsApp%20Image%202026-07-16%20at%201.40.15%20PM.jpeg",
  },
  {
    id: 2,
    title: "Storage Tank Recoating",
    category: "Storage Tanks",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_agraj-preview/artifacts/mcq9x0f4_WhatsApp%20Image%202026-07-16%20at%201.40.16%20PM.jpeg",
  },
  {
    id: 3,
    title: "Pipeline Corrosion Coating",
    category: "Pipelines",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_agraj-preview/artifacts/lb253a5x_WhatsApp%20Image%202026-07-16%20at%201.40.15%20PM%20%281%29.jpeg",
  },
  {
    id: 4,
    title: "Steel Frame Protective Coating",
    category: "Steel Structures",
    image:
      "https://customer-assets-0z36b82j.emergentagent.net/job_agraj-preview/artifacts/vtemk2k3_WhatsApp%20Image%202026-07-16%20at%201.40.16%20PM%20%281%29.jpeg",
  },
];

export const PPE = [
  { title: "Safety Helmet", icon: "HardHat" },
  { title: "Safety Belt", icon: "LifeBuoy" },
  { title: "Safety Goggles", icon: "Glasses" },
  { title: "Safety Gloves", icon: "Hand" },
  { title: "Safety Shoes", icon: "Footprints" },
  { title: "PPE Compliance", icon: "ShieldCheck" },
];

export const CLIENTS = [
  { name: "Nirma Pvt. Ltd.", sub: "" },
  { name: "Balarka Fabricon Pvt. Ltd.", sub: "Madhu Silica Pvt. Ltd." },
];

export const WHY = [
  { icon: "Users", title: "Experienced Team", desc: "Skilled manpower with 7+ years of on-site expertise." },
  { icon: "Gem", title: "Premium Materials", desc: "Only industry-grade coatings and primers." },
  { icon: "ShieldAlert", title: "Corrosion Protection", desc: "Systems that fight rust in the harshest plants." },
  { icon: "Clock", title: "Timely Delivery", desc: "Projects completed on schedule, every time." },
  { icon: "HardHat", title: "Safety Standards", desc: "Strict PPE compliance on every site." },
  { icon: "Wallet", title: "Affordable Pricing", desc: "Cost-effective solutions without compromise." },
  { icon: "Timer", title: "Long-lasting Coatings", desc: "Durable finishes that stand the test of time." },
  { icon: "Sparkles", title: "Professional Finish", desc: "Clean, precise workmanship on every surface." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Agraj Enterprise recoated our steel structures ahead of schedule with an impeccable finish. Their corrosion protection has held up remarkably well.",
    name: "Plant Maintenance Head",
    org: "Chemical Processing Unit",
  },
  {
    quote:
      "Professional team, strict safety practices, and quality workmanship. The tank recoating job exceeded our expectations.",
    name: "Site Engineer",
    org: "Caustic Soda Plant",
  },
  {
    quote:
      "Reliable, cost-effective and durable. Agraj handled our warehouse painting with zero disruption to operations.",
    name: "Operations Manager",
    org: "Manufacturing Facility",
  },
];

export const FAQS = [
  {
    q: "What types of industrial coatings do you provide?",
    a: "We provide Epoxy, PU, Alkyd and Zinc-rich coating systems, along with structural painting, surface preparation, sand blasting and complete corrosion protection solutions.",
  },
  {
    q: "Do you handle surface preparation and rust removal?",
    a: "Yes. Surface preparation is critical to coating life. We perform cleaning, grinding, sand blasting and rust treatment to achieve the correct surface profile before application.",
  },
  {
    q: "Which industries do you serve?",
    a: "We serve chemical plants, caustic soda plants, PPA plants, warehouses, factories, steel structures, industrial buildings and manufacturing plants.",
  },
  {
    q: "How do you ensure worker safety on site?",
    a: "We follow strict safety standards with mandatory PPE — safety helmets, belts, goggles, gloves and shoes — on every site, along with safe working procedures at height.",
  },
  {
    q: "How can I request a quotation?",
    a: "Use the contact form or WhatsApp us directly. Share your structure type, area and location, and we will prepare a cost-effective quotation for you.",
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Gallery", href: "#gallery" },
  { label: "Safety", href: "#safety" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];
